const { createElement } = require('react');
const { IntlProvider } = require('react-intl');
const PropTypes = require('prop-types');
function getLocale(sandbox) {
    var _a, _b, _c;
    return ((_c = (_b = (_a = sandbox === null || sandbox === void 0 ? void 0 : sandbox.appContext) === null || _a === void 0 ? void 0 : _a.getLocalizationInfo) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.locale) || 'en';
}
export function substituteCustomTokens(messages, sandbox) {
    var _a, _b, _c, _d;
    const qboContext = (_b = (_a = sandbox === null || sandbox === void 0 ? void 0 : sandbox.extensions) === null || _a === void 0 ? void 0 : _a.qbo) === null || _b === void 0 ? void 0 : _b.context;
    let formattedMessages = messages;
    if (qboContext) {
        const tokenMap = (_d = (_c = qboContext.getTokens) === null || _c === void 0 ? void 0 : _c.call(qboContext)) !== null && _d !== void 0 ? _d : {};
        formattedMessages = {};
        Object.keys(messages).forEach((key) => {
            let message = messages[key];
            if (typeof message === 'string') {
                message = message.replace(/{{(\w+)}}/g, (match, token) => { var _a; return (_a = tokenMap[token]) !== null && _a !== void 0 ? _a : match; });
                formattedMessages[key] = message;
            }
        });
    }
    return formattedMessages;
}
export function IntuitIntlProvider(props, context) {
    const { children, sandbox: propSandbox } = props;
    let { messages } = props;
    const { sandbox: contextSandbox } = context;
    const sandbox = propSandbox !== null && propSandbox !== void 0 ? propSandbox : contextSandbox;
    messages = messages && substituteCustomTokens(messages, sandbox);
    return createElement(IntlProvider, {
        locale: getLocale(sandbox),
        messages,
        children,
    });
}
IntuitIntlProvider.contextTypes = {
    sandbox: PropTypes.object,
};
export function wrapWithIntlProvider(Component, messages) {
    return function WrappedComponent(props) {
        return createElement(IntuitIntlProvider, {
            sandbox: props.sandbox,
            messages,
            children: createElement(Component, props),
        });
    };
}
//# sourceMappingURL=intl.js.map